import download from "downloadjs";

import * as dataManagement from "../api/dataManagement";

export const downloadTemplateAction = (payload) => async (
  dispatch,
  getState,
) => {
  try {
    const resp = await dataManagement.downloadTemplate(payload);

    if (resp.status === 200) {
      const disposition = resp.headers.get("content-disposition");
      let filename = "export.csv";

      if (disposition && disposition.indexOf("attachment") !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
        }
      }

      const blob = await resp.blob();
      const contentType = resp.headers.get("Content-Type");
      download(blob, filename, contentType);
    } else {
      console.warn("Unable to download template");
      throw new Error("Error downloading template", resp.statusText);
    }
  } catch (error) {
    console.error("Error downloading template", error.message);
    throw new Error("Error downloading template", error.message);
  }
};

export const importConsumptionAction = (payload) => async (
  dispatch,
  getState,
) => {
  try {
    const resp = await dataManagement.importConsumption(payload);

    if (resp.status === 200) {
      console.log("Import successful");
    } else {
      throw new Error("Error importing consumption", resp.statusText);
    }
  } catch (error) {
    console.error("Error importing consumption", error.message);
    throw new Error("Error importing consumption", error.message);
  }
};

export const rollOutAction = (payload) => async (dispatch, getState) => {
  try {
    const resp = await dataManagement.rollOut(payload);
  } catch (error) {
    console.error("Error during rollout", error.message);
  }
};
